import * as MUI from "@mui/material";
import React, { ReactNode } from "react";

interface Props {
    title: ReactNode | string;
    children: ReactNode;
}

const Tooltip: React.FC<Props> = ({ title, children }) => {
    // Check whether the child being passed in is a native HTML element that is not disabled.
    // This is used to determine if we need to wrap it in a span for the tooltip to work correctly.
    const nativeChild =
        React.isValidElement<{ disabled?: boolean }>(children) &&
        typeof children.type === "string" &&
        !children.props.disabled;

    return (
        <MUI.Tooltip title={title} disableInteractive sx={{ maxWidth: 100 }} enterDelay={500}>
            {nativeChild ? children : <span style={{ display: "inline-flex" }}>{children}</span>}
        </MUI.Tooltip>
    );
};

export default Tooltip;
